import { Component, OnInit, Input } from '@angular/core';
import { TaAllertaDownloadService } from './ta-allerta-download.service';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';

@Component({
  selector: 'ta-allerta-download',
  templateUrl: './ta-allerta-download.component.html',
  styleUrls: ['./ta-allerta-download.component.scss'],
  providers: [ TaAllertaDownloadService ]
})

export class TaAllertaDownloadComponent implements OnInit {

  @Input() giorno;
  riferimentoBollettino: any;

  promiseBusy: Promise<any>;
  dataEmissione: any;
  dataEmissioneMeteo: any;

  constructor(public restService: TaAllertaDownloadService, private newModal: NewModalService,) { }

  ngOnInit() {

    var ref = this;

    if (this.giorno == 1) {
      this.riferimentoBollettino = "OGGI";
    } else if (this.giorno == 2) {
      this.riferimentoBollettino = "DOMANI";
    }

    this.restService.findLastBollettinoInserito().then(
      data => {
        ref.dataEmissione = data.dataEmissione.split(" - ")[1] + " alle " + data.dataEmissione.split(" - ")[0];
      }
    ).catch(error => {
      ref.dataEmissione = "-";
    });
    this.restService.findLastMeteo().then(
      data => {
        const [dataStr, oraStr] = data.dataEmissione.split(" - ");
        ref.dataEmissioneMeteo = `${dataStr} alle ${oraStr}`;

      } 
    ).catch(error => {
      ref.dataEmissioneMeteo = "-";
    });

  }

  routeTo(string) {
    window.location.href = string;
  }

  downloadAvviso() {
    var ref = this;

    if(this.dataEmissione != "-"){
      ref.restService.findLastBollettinoInserito().then(
        data => {
  
          //ref.openModal(data.dataEmissione, data);
  
          this.promiseBusy = this.restService.getPDFbyte(data.urlPdf);
          this.promiseBusy.then(
            res => {
  
              //this.PDFbyte = "data:application/pdf;base64,"+res[0].base64;
              var forExecElement = document.createElement("a");
              forExecElement.id = "download_bollettino";
              forExecElement.href = "data:application/pdf;base64," + res.file;
              forExecElement.download = "avviso_allerta_(" + data.dataEmissione + ").pdf";
  
              document.body.appendChild(forExecElement);
  
              document.getElementById('download_bollettino').click();
  
              document.body.removeChild(forExecElement);
  
            }
  
          )
  
        }
      );
    } else {
      this.newModal.open("Errore", "Il download non è al momento disponibile, riprovare più tardi", "bg-danger");
      
    }

  }

  downloadBollettino() {

    var ref = this;

    if(this.dataEmissioneMeteo != "-"){
      ref.restService.findLastMeteo().then(
        data => {
  
          this.promiseBusy = this.restService.getPDFbyte(data.urlPdf);
          this.promiseBusy.then(
            res => {
  
              var forExecElement = document.createElement("a");
              forExecElement.id = "download_bollettino";
              forExecElement.href = "data:application/pdf;base64," + res.file;
              forExecElement.download = "bollettino_meteo_(" + data.dataEmissione + ").pdf";
  
              document.body.appendChild(forExecElement);
  
              document.getElementById('download_bollettino').click();
  
              document.body.removeChild(forExecElement);
  
            }
  
          )
  
        }
      );
    } else {
      this.newModal.open("Errore", "Il download non è al momento disponibile, riprovare più tardi", "bg-danger");
    }
  }
}
